import { badgeSrc } from '@/features/games/brandBadge.js';

interface BrandBadgeProps {
  /** Badge file code from `badgeCodeOf` / `providerBadgeCodeOf`; renders nothing when null. */
  code: string | null;
  label: string;
  className?: string;
}

/** The brand logo at a card's top-right: 64x24, plate baked into the image. */
export function BrandBadge({ code, label, className = '' }: BrandBadgeProps) {
  if (!code) return null;
  return (
    <img
      src={badgeSrc(code)}
      alt={label}
      width={64}
      height={24}
      loading="lazy"
      decoding="async"
      draggable={false}
      data-brand-badge={code}
      className={`pointer-events-none absolute right-2 top-2 z-[2] h-6 w-16 ${className}`}
    />
  );
}
